import React, { useEffect, useState } from 'react';
import MetricCard from './MetricCard/MetricCard';
import LockedData from './lockedtable';
import { useHeader } from '@/components/context/HeaderContext';
// import { AddCategoryModal } from '@/components/common/AddCategoryModal';
import { useGetCategoryAnalyticsQuery, useGetLockedAnalyticsQuery } from '@/store/api/analyticsApi';

const LockedContent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: lockedAnalytics } = useGetLockedAnalyticsQuery({ isLocked: true });
  const totalContent = lockedAnalytics?.totalContent ?? 0;
  const totalPlays = lockedAnalytics?.totalPlays ?? 0;
  const totalUsers = lockedAnalytics?.totalPremiumUsers ?? 0;
  const totalQrScans = lockedAnalytics?.totalQrScans ?? 0;

  const metrics = [
    {
      id: 1,
      title: 'Total Content',
      value: totalContent.toLocaleString(),
      change: '14%',
      trend: 'up' as const,
      image: '/playbtn.png',
      isPrimary: true,
    },
    {
      id: 2,
      title: 'Total Plays',
      value: totalPlays.toLocaleString(),
      change: '180.1%',
      trend: 'up' as const,
      image: '/clock.png',
      isPrimary: false,
    },
    {
      id: 3,
      title: 'Total Users',
      value: totalUsers.toLocaleString(),
      change: '12.5%',
      trend: 'up' as const,
      image: '/admin.png',
      isPrimary: false,
    },
    {
      id: 4,
      title: 'Total QR Scans',
      value: totalQrScans.toLocaleString(),
      change: '7.2%',
      trend: 'up' as const,
      image: '/qrcode.png',
      isPrimary: false,
    },
  ];

  const { setHeader } = useHeader();
  useEffect(() => {
    setHeader({
      type: 'category',
      props: {
        title: 'Locked Content',
        // lastUpdated: '14-April-2026, 3:00PM',
        actionLabel: 'Create New Category',
        onActionClick: () => setIsModalOpen(true),
      },
    });

    return () => setHeader(null);
  }, [setHeader]);

  return (
    <div className=" min-h-screen w-full">
      <div className=" px-3 sm:px-6 pt-3 sm:pt-6 grid grid-cols-1 md:grid-cols-4 gap-4 sm:gap-8">
        {metrics.map((metric, index) => (
          <MetricCard key={index} {...metric} />
        ))}
      </div>
      <LockedData />
      {/* <AddCategoryModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        isLocked={true}
      /> */}
    </div>
  );
};

export default LockedContent;
